import React from "react";
import { isClientSideRendering } from "../../../helpers/rendererType";

interface IInfogramEmbedProps {
  infogramId: string;
}

export const loadScript = () => {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "https://e.infogram.com/js/dist/embed-loader-min.js";
  script.id = "infogram-async";
  document.head.appendChild(script);
};

const InfogramEmbed: React.FC<IInfogramEmbedProps> = (props) => {
  if (isClientSideRendering() && document.getElementById("infogram-async") === null) {
    loadScript();
  }

  return (
    <div
      className="infogram-embed"
      data-id={props.infogramId} // eslint-disable-line react/destructuring-assignment
      data-type="interactive"
      data-title="Table Chart"
    />
  );
};

export { InfogramEmbed };
